import { handleActions } from 'redux-actions';

import { setUserPermissions } from '~/actions/permissions';
import { Channel, ChannelType, PermissionState } from '~/constants';

const initialState = {
  permissions: {},
  enabledChannelTypes: [],
  disabledChannelTypes: [],
};

export default handleActions(
  {
    [setUserPermissions]: (state, { payload: { permissions } }) => {
      const enabledChannelTypes = Object.keys(permissions)
        .filter((key) => permissions[key] === PermissionState.ENABLED)
        .map((type) => Channel.find(({ label }) => label === type)?.code)
        .concat(ChannelType.ECHO);

      const disabledChannelTypes = Object.keys(permissions)
        .filter((key) => permissions[key] === PermissionState.DISABLED)
        .map((type) => Channel.find(({ label }) => label === type)?.code);

      return {
        ...state,
        permissions,
        enabledChannelTypes,
        disabledChannelTypes,
      };
    },
  },
  initialState
);
